module.exports = __webpack_public_path__ + "static/media/help-icon.4ac9954a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help-icon.svg
// module id = 239
// module chunks = 0